const theme: 'light' = 'light';

interface IColors {
  azulClaro: string;
  azulEscuro: string;
  cinzaEscuro: string;
  cinzaClaro: string;
  branco: string;
  vermelho: string;
  gold: string;
  azulUnico: string;
}

export const getColors = (): IColors => {
  return {
    azulClaro: '#ffffff ',
    azulEscuro: '#ebc465', //0066B1
    cinzaEscuro: '#616161',
    cinzaClaro: '#f1f1f166',
    branco: '#ffffff',
    vermelho: '#B85151',
    gold: '#ffc439',
    azulUnico: '#1261a2',
  };
};
